import * as React from 'react'
// components
import Header from 'components/UI/Modal/Header'
import { Modal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useModalData } from 'hooks/index'
// view components
import SelectMultiValueForm from './Form'

const SelectMultiValueModal: React.FC = () => {
  const {
    hideModal,
    modalData: { handleFormSubmit, isOpen, item, width }
  } = useModalData({ modalType: Modals.SELECT_MULTI_VALUE_MODAL })

  const data = item || {}

  const initialValues = {
    title: data.label,
    description: data.description || ''
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} width={width} PaperProps={{ style: { width: '554px' } }}>
      <Header handleClearClick={hideModal}>Modify Value</Header>
      <SelectMultiValueForm
        hideModal={hideModal}
        initialValues={initialValues}
        onSubmit={handleFormSubmit && handleFormSubmit(hideModal)}
      />
    </Modal>
  )
}

export default SelectMultiValueModal
